export class Global {
	static scene: any
	static xr: any
	static xr_right: any
	static colourPickerValue = "#9419CC"
	static dialValue = 90
	static showFabric = false
	static parentPanelGrabbable = false
	static parentPlaneDragBehaviour: any
	static parentPlaneDragBehaviour1: any
	static parentPlaneBlock: any
	static parentPlaneBlock1: any
	static parentBlockHighlightColour: string
	static canDrag = false
	static anchored = true
	static dialInteraction = false
	static dialHit: boolean
	static dialPickedPoint: any
	static spatialSliderValue: any
	static spatialOpacitySliderValue: any
	static spatialSizeSliderValue: any
	static spatialDialValueChange: any
	static spatialColourValueChange: any
}
